<template>
    <div>

        <!--<success :rowid="$route.params.rowid" :cont="$route.params.cont" :cust="$route.params.cust" :roleID="this.role" v-if="showSuccess" />-->

        <table>

            <tbody class="print-body">

                <div class="relative">
                    <!--<img class="center-img" src="../assets/img/ardiowner.jpg" style="position:relative;">-->
                    <img class="center-img" src="../assets/img/sd.png" style="position:relative;">
                    <!--<div class="divide3">
                        <div class="absolute">
                            <div class=" d-flex">
                                <img class="icon" src="../assets/img/ardi-logo.svg" width="200">
                                <div class="pl-5 mt-1">
                                    <h5 style="letter-spacing: 7px; font-weight: bold; color: #005745; text-align: start; " class="nino-mtavruli mt-2">
                                        როცა ფიქრობ<br>
                                        მხოლოდ კარგზე
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="white-div">

                        <div style="text-align: start; max-width: 37%; max-width:100%;">
                            <h4 style="color: black; font-weight: bold;" class="nino-mtavruli">გენერალური ხელშეკრულება</h4>
                            <h2 style="color: #005745; font-weight: bold; letter-spacing: 4px" class="nino-mtavruli mt-5">ქონების<br>საკრედიტო<br>დაზღვევა<br></h2>
                            <h4 style="color: black; font-weight: bold;" class="mt-5">
                                JSC ARDI INSURANC<br>
                                Credit Property Insuranc<br>
                                General Condition,Version C/PRO<br>
                            </h4>
                        </div>


                    </div>-->
                    <!--<div class="contact-info d-flex ">
                        <div>
                            <span class="nino-mtavruli">
                                ვაჟა-ფშაველას გამზ.3<br />
                                თბილისი, საქართველო
                            </span>
                        </div>
                        <div class="mr-3 ml-3" style="border-left: 3px solid #d1d1d1; "></div>
                        <div>
                            <span class="nino-mtavruli">
                                3,VAZHA-PSHAVELA AVE. <br />
                                TBILISI,GEORGIA
                            </span>
                        </div>
                        <div class="mr-3 ml-3" style="border-left: 3px solid #d1d1d1;"></div>
                        <div>
                            <span class="nino-mtavruli" >
                                T:995 322 10 10 10<br />
                                F: 995 322 51 58 16
                            </span>
                        </div>
                        <div class="mr-3 ml-3" style="border-left: 3px solid #d1d1d1; "></div>
                        <div>
                            <span class="nino-mtavruli">
                                i: www.ardi.ge<br />
                                e: official@ardi.ge
                            </span>
                        </div>




                    </div>-->
                </div>

                <div style="margin-left: 2%; margin-right: 2%; margin-top: 2%;">
                    <div class="general-test">
                        <img class="mb-4 logo-pr" src="../assets/img/logoonly.png" >
                        <div style=" border-top: 3px solid #ededed;" class="mt-2 mb-4"></div>
                        <span style="color: #005745; font-size: 19px;">
                            <span style="font-weight: bold;">
                                ქონების საკრედიტო დაზღვევის პირობები C/PRO <br />
                                გენერალური ხელშეკრულება N GAC–C-LIFE-PRO-CPM-01.04.2020-ის 01/12/2021-ის მიხედვით <br />
                            </span>
                            <span style="color: white; background-color: #005745; font-weight: bold;">ბიზნეს სესხის</span>  <span style="color: black;">უზრუნველყოფაში არსებული უძრავი /მოძრავი ქონების დაზღვევის შესახებ</span>


                        </span>
                        
                        <div>
                            <div style="background-color: #ededed;" class="mt-4">
                                <span style="font-size: 19px; " class="title-color">ზოგადი დებულებები</span>
                                <div style="border-top: 3px solid #005745; " class="mt-2"></div>
                            </div>

                            <div style="font-size:14px">
                                <div class="d-flex">
                                    <div>1.</div>
                                    <span class="pl-4">
                                        წინამდებარე „ქონების  საკრედიტო დაზღვევის პირობები” (შემდეგ– „პირობები“) არეგულირებს ურთიერთობას მზღვეველსა და დამზღვევს
                                        ( ასევე დაზღვეულს, მოსარგებლეს და ქონების მესაკუთრეს ) შორის, რომელიც წარმოიშობა დამზღვევის მიერ
                                        გაცემული სესხის უზრუნველსაყოფად გამოყენებული ქონების მზღვეველთან დაზღვევასთან დაკავშირებით.
                                    </span>
                                </div>


                                <div class="d-flex">
                                    <div>2.</div>
                                    <span class="pl-4">
                                        სადაზღვევო რისკები განისაზღვრება პოლისით. ამასთან, მათ შეიძლება დაემატოს ან მათგან ამოღებული იქნეს ცალკეული რისკ (ებ)ი
                                        ან რისკის ჯგუფები.
                                    </span>
                                </div>

                                <div class="d-flex">
                                    <div>3.</div>
                                    <span class="pl-4">
                                        დაზღვეული ობიექტ(ებ)ი, სადაზღვევო თანხა და (ქვე)ლიმიტები, ფრანშიზის ოდენობა, სადაზღვევო ტერიტორია და პერიოდი, პრემიის
                                        ოდენობა განისაზღვრება პოლისით.
                                    </span>
                                </div>

                                <div class="d-flex">
                                    <div>4.</div>
                                    <span class="pl-4">
                                        პოლისის დებულებების განმარტებისას გამოიყენება ეს პირობები.
                                    </span>
                                </div>

                                <div class="d-flex">
                                    <div>5.</div>
                                    <span class="pl-4">
                                        მხარეებს შორის შეტყობინება
                                        და თანხმობა შედგება წერილობით ან შეთანხმებული ელექტრონული ფოსტით. მხარე პასუხისმგებელია მეორე
                                        მხარისათვის მიწოდებული ინფორმაციის სისწორეზე, სიზუსტესა და ლეგალურობაზე, წინააღმდეგ შემთხვევაში მეორე მხარეს წარმოეშვება
                                        უფლება, არ შეასრულოს შესაგებელი ვალდებულება.
                                    </span>
                                </div>


                            </div>



                        </div>

                        <div>
                            <div style="background-color: #ededed;">
                                <span style="font-size: 19px;" class="title-color">მუხლი 1 | ტერმინთა განმარტება</span>
                                <div style="border-top: 3px solid #005745; " class="mt-2"></div>
                            </div>
                            <div style="font-size:14px">
                                <div class="d-flex">
                                    <div>1.1</div>
                                    <span class="pl-4">
                                        <span class="title-color">დამზღვევი</span> – სს “პროკრედიტ ბანკი” (ს/კ 204851197),რომელმაც
                                        მზღვეველთან დადო ხელშეკრულება და ვალდებულია შეთანხმებული
                                        ოდენობითა და ვადაში გადაიხადოს პრემია. დამზღვევი იმავდროულად არის - მოსარგებლე.
                                    </span>
                                </div>
                                <div class="d-flex">
                                    <div>1.2</div>
                                    <span class="pl-4">
                                        <span class="title-color">დაზღვეული</span> –  იურიდიული პირი  ან პირთა გაერთიანება , რომელმაც გააფორმა გენერალური
                                        / საკრედიტო ხელშეკრულება 1xxzxwzq“დამზღვევთან"
                                        /მოსარგებლესთან (მსესხებელი/თანამსესხებელი/სოლიდარული მსესხებელი) და რომელთა მიმართაც ხორციელდება
                                        დაზღვევა. პოლისს შესაძლებელია ხელს აწერდეს მხოლოდ ერთი დაზღვეული,
                                        მაგრამ დაზღვეულად მიიჩნევა ყველა ის იურიდიული პირი
                                        და/ან პირთა გაერთიანება, რომლებმაც გააფორმეს გენერალური და/ან საკრედიტო ხელშეკრულება ბანკთან წინამდებარე ხელშეკრულების
                                        საფუძველზე დაზღვეული უძრავი/მოძრავი ნივთების უზრუნველყოფით.

                                    </span>
                                </div>
                                <div class="d-flex">
                                    <div>1.3</div>
                                    <span class="pl-4">
                                        <span class="title-color">მოსარგებლე</span> – პოლისში მოსარგებლედ მითითებული პირ(ებ)ი, რომელიც სადაზღვევო შემთხვევის დადგომისას იღებს სადაზღვევო
                                        ანაზღაურებას. მოსარგებლე არის დამზღვევი ან მისი თანხმობით სხვა პირი.

                                    </span>
                                </div>

                                <div class="d-flex">
                                    <div>1.4</div>
                                    <span class="pl-4">
                                        <span class="title-color">ქონების მესაკუთრე</span> - პირი, რომლის საკუთრებაშია დაზღვევული უძრავი ნივთი. საკუთრების უფლება უნდა
                                        დასტურდებოდეს საჯარო რეესტრის ამონაწერის მიხედვით.
                                    </span>
                                </div>


                                <div class="d-flex">
                                    <div>1.5</div>
                                    <span class="pl-4">
                                        <span class="title-color">ხელშეკრულება</span> – ეს პირობები, გენერალური ხელშეკრულება და პოლისი ერთიანობაში.
                                    </span>
                                </div>

                                <div class="d-flex">
                                    <div>1.6</div>
                                    <span class="pl-4">
                                        <span class="title-color">პოლისი (სადაზღვევო პოლისი)</span>
                                        –
                                        მზღვეველის მიერ გაცემული მოწმობა, რომელიც შეიცავს ინფორმაციას მზღვეველის, დამზღვევის,
                                        დაზღვეულის, მოსა
                                        რგებლის, სადაზღვევო პრემიის, მოქმედების ვადისა და სადაზღვევო რისკების შესახებ.
                                    </span>
                                </div>

                                <div class="d-flex">
                                    <div>1.7</div>
                                    <span class="pl-4">
                                        <span class="title-color">პირი</span>
                                        -
                                        იურიდიული პირი, პირთა გაერთიანება, რომელიც არ არის იურიდიული პირი, სახელმწიფო დაწესებულება.
                                    </span>
                                </div>

                                <div class="d-flex">
                                    <div>1.8</div>
                                    <span class="pl-4">
                                        <span class="title-color">ქონება</span>–
                                        სესხის უზრუნველსაყოფად დატვირთული შენობა - ნაგებობა
                                        ან სხვა კონსტრუქცია მთლიანად ან მის ნაწილი, აგრეთვე ანკეტა
                                        -
                                        განაცხადში მითითებული და პოლისით დაზღვეული მის შიგთავსი ნივთ(ებ)ი.

                                    </span>
                                </div>

                                <div class="d-flex">
                                    <div>1.9</div>
                                    <span class="pl-4">
                                        <span class="title-color">სადაზღვევო რისკი</span>–
                                        სადაზღვევო შემთხვევის დადგომის შესაძლებლობა, რომლის გამოც ხდება დაზღვევა. მისი დადგომის ალბათობა
                                        დამოკიდებულია სხვადასხვა რისკ  -
                                        ფაქტორზე: ქონების სახე, რაოდენობა, ღირებულება, დანიშნულება, ადგილმდებარეობა და დამზღვევის
                                        მიერ შევსებული ანკეტა - განაცხადის სხვა მონაცემები.

                                    </span>
                                </div>

                                <div class="d-flex">
                                    <div>1.10</div>
                                    <span class="pl-4">
                                        <span class="title-color">სადაზღვევო შემთხვევა</span>–
                                        ქონების დაზიანების ან განადგურების შემთხვევა, გარდა წინამდებარე პირობებით გა
                                        თვალისწინებული
                                        სტანდარტული გამონაკლისებისა.


                                    </span>
                                </div>

                                <div class="d-flex">
                                    <div>1.11</div>
                                    <span class="pl-4">
                                        <span class="title-color">ზიანი</span>–
                                        ქონების დაზიანება/განადგურება დაზღვეული რისკის დადგომის შედეგად. დაზღვევა ვრცელდება მხოლოდ პირდაპირ ქონებრივ
                                        ზიანზე, რომელიც უშუალოდ დაზღვეული რისკის შედეგია.

                                    </span>
                                </div>
                                <div class="d-flex">
                                    <div>1.12</div>
                                    <span class="pl-4">
                                        <span class="title-color">განადგურება</span>–
                                        ქონების ისეთი დაზიანება, როდესაც რეალური აღდგენის (მათ შორის, სხვა ანაზღაურებადი თანმდევი ხარჯების ჩათვლით)
                                        ღირებულება ტოლია ან აღემატება უშუალოდ სადაზღვევო შემთხვევის დადგომამდე მისი რეალური საბაზრო ღირებულების, ცვეთის
                                        გათვალისწინებით.


                                    </span>
                                </div>
                                <div class="d-flex">
                                    <div>1.13</div>
                                    <span class="pl-4">
                                        <span class="title-color">სადაზღვევო თანხა</span>–
                                        პოლისით განსაზღვრული სადაზღვევო ანაზღაურების მაქსიმალური ოდენობა.

                                    </span>
                                </div>
                                <div class="d-flex">
                                    <div>1.14</div>
                                    <span class="pl-4">
                                        <span class="title-color">სადაზღვევო ლიმიტი</span>–
                                        “დამზღვევსა" და “მზღვეველს" შორის სადაზღვევო პოლისით გათვალისწინებული მზღვეველის პასუხისმგებლობის
                                        მაქსიმალური ოდენობა, რომელიც შეადგენს ქონების რეალური საბაზრო ღირებულების 100% - ს.
                                        სადაზღვევო ლიმიტი წარმოადგენს
                                        „მზღვეველის“ პასუხისმგებლობის მაქსიმალურ, ზღვრულ ოდენობას.

                                    </span>
                                </div>
                                <div class="d-flex">
                                    <div>1.15</div>
                                    <span class="pl-4">
                                        <span class="title-color">სადაზღვევო ქველიმიტი</span>–
                                        სადაზღვევო ლიმიტის ფარგლებში სადაზღვევო ანაზღაურების მაქსიმალური შესაძლო ოდენობა ზიანის თითო
                                        შემთხვევასთან ან/და ცალკეულ ობიექტთან მიმართებით.


                                    </span>
                                </div>

                                <div class="d-flex">
                                    <div>1.16</div>
                                    <span class="pl-4">
                                        <span class="title-color">სადაზღვევო ანაზღაურების თანხა</span>–
                                        სადაზღვევო შემთხვევის დადგომისას, “მოსარგებლისათვის" გასაცემი თანხა, რომელიც ემთხვევა
                                        ქონების რეალურ საბაზრო ღირებულებას ან პროპორციული დაზღვევის შემთხვევაში ნაკლებია მასზე. სადაზღვევო ანაზღაურების თანხა არ
                                        შეიძლება იყოს სადაზღვევო ლიმიტზე მეტი.


                                    </span>
                                </div>

                                <div class="d-flex">
                                    <div>1.17</div>
                                    <span class="pl-4">
                                        <span class="title-color">სადაზღვევო პრემია</span>–
                                        დაზღვევის ღირებულება, რომელიც უნდა გადაუხადოს დამზღვევმა მზღვეველს დაზღვევის საფასურად. პრემიის
                                        ოდენობა განისაზღვრება სადაზღვევო პოლისით.


                                    </span>
                                </div>

                                <div class="d-flex">
                                    <div>1.18</div>
                                    <span class="pl-4">
                                        <span class="title-color">უპირობო ფრანშიზა</span>–
                                        ზიანის ის თანხობრივი ან პროცენტული ნაწილი , რომელსაც ყოველი ცალკეული სადაზღვევო შემთხვევის დადგომისას
                                        და ცალკეული დაზღვეული ქონების მიმართ მზღვეველი არ აანაზღაურებს.


                                    </span>
                                </div>

                                <div class="d-flex">
                                    <div>1.19</div>
                                    <span class="pl-4">
                                        <span class="title-color">სტანდარტული გამონაკლისი</span>–
                                        შემთხვევა, რომელიც სადაზღვევო შემთხვევად არ ითვლება და არ ანაზღაურდება.


                                    </span>
                                </div>
                                <div class="d-flex">
                                    <div>1.20</div>
                                    <span class="pl-4">
                                        <span class="title-color">პროპორციული დაზღვევა</span>–
                                        დაზღვევა, როდესაც მზღვეველი ანაზღაურებს ზიანის პროპორციულ ნაწილს, შეფარდებულს სადაზღვევო თანხასა
                                        და ქონების რეალურ საბაზრო ღირებულებას შორის. პროპორციული დაზღვევის პრინციპით მზღვეველი ანაზღაურებს ზიანის ნაწილს იმ
                                        პროპორციით, რა პროპორციაც არსებობს პოლისში მითითებულ სადაზღვევო თანხასა და ქონების რეალურ საბაზრო ღირებულებას შორის.


                                    </span>
                                </div>

                                <div class="d-flex">
                                    <div>1.21</div>
                                    <span class="pl-4">
                                        <span class="title-color">წყალგაყვანილობის, წყლის გათბობის ან საკანალიზაციო სისტემის ავარია</span>–
                                        წყლის არაკონტროლირებადი გამოდინება დაზღვეულ შენობა -
                                        ნაგებობაში არსებული წყალგაყვანილობის, წყლის გათბობისა ან/და საკანალიზაციო სისტემიდან.


                                    </span>
                                </div>

                                <div class="d-flex">
                                    <div>1.22</div>
                                    <span class="pl-4">
                                        <span class="title-color">სტიქიური უბედურება</span>–
                                        უეცრად წარმოშობილი ბუნებრივი ხდომილება, რომელიც იწვევს დამაზიანებელ ეკოლოგიურ შედეგებს.


                                    </span>
                                </div>

                                <div class="d-flex">
                                    <div>1.23</div>
                                    <span class="pl-4">
                                        <span class="title-color">ძლიერი ქარი</span>–
                                        ჰაერის მასების გადაადგილება 20 მ/წმ

                                    </span>
                                </div>
                                <div class="d-flex">
                                    <div>1.24</div>
                                    <span class="pl-4">
                                        <span class="title-color">მიწისძვრა</span>–
                                        ბუნებრივი ან ტექნოგენური (ხელოვნური) მოვლენებით გამოწვეული მიწისქვეშა ბიძგები,
                                        რომელიც იწვევს დედამიწის ზედაპირის რყევით მოძრაობას.


                                    </span>
                                </div>
                                <div class="d-flex">
                                    <div>1.25</div>
                                    <span class="pl-4">
                                        <span class="title-color">მეწყერი</span>–
                                        მიწის დიდი მასივის ჩამოწოლა საკუთარი სიმძიმის შედეგად.


                                    </span>
                                </div>
                                <div class="d-flex">
                                    <div>1.26</div>
                                    <span class="pl-4">
                                        <span class="title-color">ქურდობა გატეხვით ან ფარული შეღწევით</span>–
                                        ქურდობა, ჩადენილი კარის/კარიბჭის ან მისი საკეტის გატეხვით, კედლის/ღობის განგრევით,
                                        ფანჯრის გატეხვით ან ცხაურების დაზიანებით ან ფარული შეღწევით, რომელიც დასტურდება შესაბამისი ორგანოებით.


                                    </span>
                                </div>
                                <div class="d-flex">
                                    <div>1.27</div>
                                    <span class="pl-4">
                                        <span class="title-color">ხანძარი</span>–
                                        წვის არაკონტროლირებადი პროცესი, რომელსაც თან ახლავს ქონების დაზიანება და
                                        რომელიც საფრთხეს უქმნის ადამიანების ჯანმრთელობასა და სიცოცხლეს.


                                    </span>
                                </div>
                                <div class="d-flex">
                                    <div>1.28</div>
                                    <span class="pl-4">
                                        <span class="title-color">წყალდიდობა</span>–
                                        ზედაპირული წყლის დონის მატება ან წყლის გადმოსვლა, გამოწვეული ტალღით, მიქცევით, მოქცევით, ჯებირის რღვევით,
                                        ნაკადის გაძლიერებით, რაც თავის მხრივ შესაძლოა გამოწვეულ იქნეს ბუნებრივი
                                        ან ტექნოგენური (ხელოვნური) მოვლენებით (შტორმის გარდა).


                                    </span>
                                </div>
                                <div class="d-flex">
                                    <div>1.29</div>
                                    <span class="pl-4">
                                        <span class="title-color">შტორმი</span>–
                                        ამინდის მდგომარეობა, რომელიც შეიძლება მოიცავდეს
                                        ქარიშხალს, ტაიფუნს, ტროპიკულ ქარიშხალს,ციკლონს, წვიმას, სეტყვას,  მეხს, ქარბორბალას ან/და წყალდიდობას.


                                    </span>
                                </div>

                                <div class="d-flex">
                                    <div>1.30</div>
                                    <span class="pl-4">
                                        <span class="title-color">ცვეთა (ამორტიზაცია)</span>–
                                        აქტივების აღრიცხვის მეთოდი, რომელიც ითვალისწინებს მათი ღირებულების შემცირებას განსაზღვრულ დროთა განმავლობაში.


                                    </span>
                                </div>

                                <div class="d-flex">
                                    <div>1.31</div>
                                    <span class="pl-4">
                                        <span class="title-color">სადაზღვევო ტერიტორია</span>–
                                        პოლისში მითითებული ტერიტორიული ფარგლები ან/და მისამართი, სადაც განთავსებულია დაზღვეული ქონება.
                                        დაზღვევა არ ვრცელდება იმ ქონებაზე, რომელიც ტოვებ ს სადაზღვევო ტერიტორიას, თუ კონკრეტულად სხვა რამ არ შეთანხმდა.


                                    </span>
                                </div>

                            </div>

                        </div>
                        <div>
                            <div style="background-color: #ededed;">
                                <span style="font-size: 19px;" class="title-color">მუხლი 2 | ქონება</span>
                                <div style="border-top: 3px solid #005745; " class="mt-2"></div>
                            </div>
                        </div>

                    </div>
                </div>

            </tbody>


        </table>



    </div>
</template>

<script>
    import Signature from "@/Procredit/components/Signature";
    import Success from "@/Procredit/components/Success";
    export default {
        name: "ContractPreview",
        components: {
            Signature,
            Success
        },
        data() {
            return {
                data: null,
                rejectStatus: null,
                checked: null,
                loadingSpinner: true,
                role: 1,
                cont: this.$route.params.cont,
                cust: this.$route.params.cust,
                denial: false,
                status: false,
                status1: false,
                //approvestatus: false,
                response: '',
                showSuccess: false,
                statusApprove: 0,
                canceledLink: 0
            }
        },

        mounted() {




            //this.$http.get(`/policy/GetProInfo/${this.cont}/${this.cust}`).then(r => {
            //  this.data = r.data;
            //  console.log(r.data);
            //}).catch((e) => {
            //  console.log(e)
            //})

        },

        methods: {

        }
    }
</script>

<style scoped>
    @import "~bpg-nino-mtavruli";

    .nino-mtavruli {
        font-family: "BPG Nino Mtavruli", sans-serif;
    }

    .general-test {
        width: 65%;
        margin-left: auto;
        margin-right: auto;
    }

    .title-color {
        color: rgb(20 171 139);
    }

    div.absolute {
        top: 80px;
        right: 0;
        margin: 0 auto;
        width: 502px;
    }
    .logo-pr{
        width:15%;
    }
    .absolute1 {
        top: 80px;
    }

    .contact-info {
        color: white;
        position: absolute;
        width: 100%;
        bottom: 172px;
        left: 70px;
        color: #d1d1d1;
        letter-spacing: 1px;
    }

    .relative {
        position: relative;
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 65%;
    }

    .white-div {
        position: absolute;
        top: 50%;
        max-width: 540px;
        width: 100%;
        left: 0;
        background-color: #fff;
        height: 470px;
        display: flex;
        align-items: center;
        transform: translateY(-50%);
        display: flex;
        justify-content: center;
    }

    .center-img {
        width: 100%;
    }

    .divide2 {
        position: absolute;
        top: 28%;
        width: 79%;
    }

    .divide3 {
        position: absolute;
        width: 92%;
        top: 7%;
    }

    .parent {
        position: relative;
        top: 0;
        left: 0;
    }

    .imginbox {
        position: absolute;
        top: 30px;
        left: 30px;
    }

    .approve-cancel-btn {
        width: 50%;
        height: 130%;
        font-size: 21px;
        border-radius: 10px;
    }

    .border-green {
        border: 2px solid #00a987 !important;
    }

    .pol-number {
        font-size: 17px;
        font-weight: bold;
    }

    .header-text {
        font-size: 32px;
        font-weight: bold;
        color: #005745;
        height: 71px;
        line-height: 100px;
        text-align: center;
    }

    .description-box {
        background-color: #00a987;
        color: #fff;
    }

    .print-body {
        margin-bottom: 5rem;
    }

    .value-background {
        border-bottom: 1px solid #b0b1b3 !important;
        border-right: 1px solid #b0b1b3 !important;
        border-left: 1px solid #b0b1b3 !important;
        font-size: 14px;
    }

    .value-background-rb {
        border-bottom: 1px solid #b0b1b3 !important;
        border-left: 1px solid #b0b1b3 !important;
        font-size: 14px;
    }

    .value-background-lrb {
        border-bottom: 1px solid #b0b1b3 !important;
        border-right: 1px solid #b0b1b3 !important;
        border-left: 1px solid #b0b1b3 !important;
        font-size: 14px;
    }

    .border-mn {
        border: 1px solid #b0b1b3 !important;
        font-size: 14px;
    }

    .content-header {
        background-color: #005745;
        color: #fff;
        font-size: 14px;
        font-weight: bold;
    }

    .content-header1 {
        background-color: #007961;
        color: #fff;
        font-size: 14px;
        font-weight: bold;
    }

    .description {
        background-color: #007961;
        color: #fff;
        font-size: 14px;
    }

    .description-top {
        background-color: #00A788;
        color: #fff;
    }


    .border-bottom-mn {
        border-bottom: 1px solid #b0b1b3 !important;
    }

    .border-right-mn {
        border-right: 1px solid #b0b1b3 !important;
    }








    .print-body {
        margin-bottom: 5rem;
    }

    .payment-block {
        width: 51%;
    }

    table {
        width: 100%;
    }


    .pay-border-left {
        border-left: 1px solid #41A546;
    }

    .pay-head-border {
        border-collapse: collapse;
        border-bottom: 1px solid #b0b1b3 !important;
        border-right: 1px solid #b0b1b3 !important;
    }


    #print-header {
        padding: 15px 0;
        display: table-header-group;
    }


    .payment-md-border {
        border: 1px solid #00A886;
        border-collapse: collapse;
        font-size: 10pt;
    }

    .md-text {
        width: 62%
    }

    .height-sm {
        height: 66px;
    }

    .footer-pic {
        width: 330px;
    }

    @media (max-width: 550px ) {
        .general-test {
            width: 100%;
        }

        .relative {
            width: 100%;
        }
    }



    @media (max-width: 1903px ) {
        .absolute {
            width: 395px;
        }

        h5 {
            font-size: 16px;
        }

        .icon {
            width: 120px;
        }
    }






    @media (max-width: 1700px) {
        h2 {
            font-size: 34px;
        }

        h4 {
            font-size: 19px;
        }

        .icon {
            width: 100px;
        }

        h5 {
            font-size: 14px;
        }
    }

    @media (max-width: 1310px) {

        h2 {
            font-size: 24px;
        }

        h4 {
            font-size: 14px;
        }

        .divider {
            height: 470px !important;
        }
    }


    @media (max-width: 1000px) {

        h2 {
            font-size: 20px;
        }

        h4 {
            font-size: 11px;
        }
    }










    @media (max-width: 500px) {
        .header_logo_property {
            width: 100%;
        }

        .sm-text {
            width: 100%
        }

        .hide-logo-sm {
            display: none;
        }

        .height-sm {
            height: 77px;
        }

        .footer-pic {
            width: 250px;
        }

        .payment-block {
            width: 53%;
        }

        .pl-sm {
            padding-left: .5rem !important;
        }

        .txt-center-sm {
            text-align: center !important;
        }

        .mt-sm {
            margin-top: 32px !important;
        }

        .header-text {
            font-size: 21px;
        }
    }


    .loader {
        -ms-flex: 0 1 auto;
        flex: 0 1 auto;
        -ms-flex-direction: column;
        flex-direction: column;
        -ms-flex-positive: 1;
        flex-grow: 1;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        -ms-flex-preferred-size: 25%;
        flex-basis: 25%;
        max-width: 25%;
        height: 200px;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-pack: center;
        justify-content: center;
        display: none;
    }

    .loader-overlay {
        overflow: hidden
    }

        .loader-overlay .loader {
            display: flex;
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
            z-index: 333;
            width: 100%;
            height: 100%;
            position: fixed;
            z-index: 99999999;
        }

    .loader-overlay {
        position: relative;
        width: 100%;
        height: 100%;
        /* background: #ccc; */
        z-index: 999;
    }

        .loader-overlay:after {
            position: fixed;
            content: '';
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: #efefef91;
            z-index: 9999999;
        }

    .square-spin > div {
        width: 50px;
        height: 50px;
        background: #00A987;
        -webkit-animation: square-spin 3s 0s cubic-bezier(.09, .57, .49, .9) infinite;
        animation: square-spin 3s 0s cubic-bezier(.09, .57, .49, .9) infinite;
    }

        .square-spin > div img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

    @-webkit-keyframes square-spin {
        25% {
            -webkit-transform: perspective(100px) rotateX(180deg) rotateY(0);
            transform: perspective(100px) rotateX(180deg) rotateY(0);
        }

        50% {
            -webkit-transform: perspective(100px) rotateX(180deg) rotateY(180deg);
            transform: perspective(100px) rotateX(180deg) rotateY(180deg);
        }

        75% {
            -webkit-transform: perspective(100px) rotateX(0) rotateY(180deg);
            transform: perspective(100px) rotateX(0) rotateY(180deg);
        }

        100% {
            -webkit-transform: perspective(100px) rotateX(0) rotateY(0);
            transform: perspective(100px) rotateX(0) rotateY(0);
        }
    }
</style>